import { AfterViewInit, Component, inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { states } from '../../ui/quick-search/quick-search.types';

@Component({
  selector: 'sbd-app-address-form',
  templateUrl: './address-form.component.html',
  standalone: false,
})
export class AddressFormComponent implements OnInit, AfterViewInit {
  @Input() formGroup!: FormGroup;
  @Input() title?: string;
  @Input() physicalAddress: boolean = false;
  @Input() contactAddress: boolean = false;
  @Input() prefix?: string = '';
  @Input() customPrepend?: string = 'address_';
  @Input() verifyAddressButton: boolean = false;
  @Input() showStateLabel: boolean = false;
  @Input() onVerifyAddress?: () => void;
  @Input() showCounty: boolean = true;

  // addressForm: UntypedFormGroup;
  _formBuilder = inject(FormBuilder);
  states: string[] = [];
  lookupStates = states;

  defaultLabels = <AddressFormLabel>{
    address_street_1_label: 'Address Line 1',
    address_street_2_label: 'Address Line 2',
    address_street_3_label: 'Address Line 3',
    address_city_label: 'City',
    address_state_abbreviation_label: 'State',
    address_zip_label: 'Zip Code',
    address_county_label: 'County',
  };

  contactAddressFormLabels: AddressFormLabel = {
    address_street_1_label: 'Contact Address 1',
    address_street_2_label: 'Contact Address 2',
    address_city_label: 'Contact City',
    address_state_abbreviation_label: 'Contact State',
    address_zip_label: 'Contact Zip',
    address_county_label: 'Contact County',
  };

  physicalAddressFormLabels: AddressFormLabel = {
    address_street_1_label: 'Physical Address 1',
    address_street_2_label: 'Physical Address 2',
    address_city_label: 'Physical Address City',
    address_state_abbreviation_label: 'Physical Address State',
    address_zip_label: 'Physical Address Zip',
    address_county_label: 'Physical Address County',
  };


  constructor() {
  }

  ngOnInit() {

    if (this.showStateLabel) {
      this.states = Object.values(states);
    } else {
      this.states = Object.keys(states);
    }

    if (this.physicalAddress) {
      this.defaultLabels = this.physicalAddressFormLabels;
    } else if (this.contactAddress) {
      this.defaultLabels = this.contactAddressFormLabels;
    }

  }


  isAddressVerified(): boolean {
    return this.formGroup.get('address_verified')?.value;
  }


  ngAfterViewInit() {
  }

  protected readonly Object = Object;
}


export interface AddressFormLabel {
  address_street_1_label?: string;
  address_street_2_label?: string;
  address_street_3_label?: string;
  address_city_label?: string;
  address_state_abbreviation_label?: string;
  address_zip_label?: string;
  address_county_label?: string;
}
